import indexedDBHelper from '@/helper/indexedDBHelper';
import { useRootStore } from '@/store/root';

export const getKeyFromPath = (fullPath, keyField) => {
  const keyFieldLength = keyField.split('/').length || 1;
  const splittedPath = fullPath.split('/');

  return splittedPath.slice(-keyFieldLength).join('/');
};

const getPath = (keyField = '') =>
  keyField
    .split('/')
    .map((part) => `:${part}`)
    .join('/');

const routes = async () => {
  // ATTENTION: this is the major Init entry for IndexedDB. Move wisely.
  const data = await indexedDBHelper.getData('meta');
  const { modules } = data;
  if (!modules)
    return new Promise((resolve) =>
      resolve([
        {
          path: '/:pathMatch(.*)*',
          redirect: (to) => ({
            name: 'login',
            query: { redirect: to.fullPath },
          }),
        },
      ]),
    );

  return Object.entries(modules).map(([type, metaConfig]) => {
    const keyField = metaConfig.keyFields?.query || '';

    return {
      path: type,
      meta: {
        public: false,
      },
      component: () => import('@/layouts/Main.vue'),
      children: [
        {
          path: '',
          redirect: '/', // Redirect if no id
          name: type,
        },
        {
          path: getPath(keyField) || ':id',
          name: `${type}.detail`,

          beforeEnter: async ({ fullPath }, from, next) => {
            const key = getKeyFromPath(fullPath, keyField);
            useRootStore().parentObject = { type, key };
            next();
          },
          component: () => import('@/views/detail/Detail/Detail'),
          props: ({ fullPath }) => ({
            type,
            objectKey: getKeyFromPath(fullPath, keyField),
          }),
        },
      ],
    };
  });
};

export default await routes();
